export const SITE = {
  name: "Maritime Thermal Solutions",
  shortName: "Maritime Thermal",
  phone: "(902) 706-6287",
  phoneHref: "tel:+19027066287",
  email: "info@maritimethermalsolutions.com",
  emailHref: "mailto:info@maritimethermalsolutions.com",
  address: "3600 Kempt Rd, Halifax, NS B3K 4X8",
  hours: "Monday – Friday, 9:00 AM – 5:00 PM",
  serviceArea: "All of Nova Scotia",
  logoUrl: "/assets/MTSLogoTransparent.png",
  iconUrl: "/assets/MTSIconTransparent.png",
  heroImage: "https://images.unsplash.com/photo-1595336605453-d0ea24263c6e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxQZWdneSUyN3MlMjBDb3ZlJTIwbGlnaHRob3VzZXxlbnwwfHx8fDE3ODAzNTk3MDR8MA&ixlib=rb-4.1.0&q=85",
  accentImage: "https://images.pexels.com/photos/7575473/pexels-photo-7575473.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  homeImage: "https://images.unsplash.com/photo-1553550319-d8d5393e1c80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxyZXNpZGVudGlhbCUyMGhvdXNlJTIwc25vd3l8ZW58MHx8fHwxNzgwMzU5NzA0fDA&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/verify", label: "Verify a Representative" },
  { to: "/contact", label: "Contact" },
];

export const SERVICE_AREAS = [
  "Halifax", "Dartmouth", "Bedford", "Sackville",
  "Truro", "Annapolis Valley", "South Shore",
  "North Shore", "Cape Breton",
];
